import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, computed, onBeforeMount, toRef, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { validatePassword } from '@/utils/validator'
import AuthService from '@/services'
import { ResetPasswordPayload } from '@/models'
import TextField from '@/components/TextField.vue'
import PageTitle from '@/components/PageTitle.vue'
import AlertBanner from '@/components/AlertBanner.vue'
import { AlphaButtonAv } from '@op-frontend/vue2tifywind';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  props: {
	token: {
		type: String,
		required: true
	}
},
  setup(__props) {

const props = __props;

const useRouter = () => {
	const { proxy } = getCurrentInstance()
	const router = proxy.$router
	return router
}

const { t } = useI18n()
const router = useRouter()

// eslint-disable-next-line


const token = toRef(props, 'token')

const form: ResetPasswordPayload = reactive<ResetPasswordPayload>({
	token: token.value,
	password: ''
})
const errors = reactive<Record<string, string>>({
	password: ''
})
const isErrorPassword = computed<boolean>(() => !!errors.password)
const showSuccessAlert = ref<boolean>(false)
const showFailedAlert = ref<boolean>(false)
const isTokenValid = ref<boolean>(false)

onBeforeMount(async () => {
	isTokenValid.value = await AuthService.checkTokenRequest(token.value)
	showFailedAlert.value = !isTokenValid.value
})

const validateForm = () => {
	if (!form.password.length) errors.password = 'errors.password__required'
	else if (!validatePassword(form.password)) errors.password = 'errors.password__invalid-length'
	else errors.password = ''
}

const setPassword = (val: string) => {
	form.password = val
	validateForm()
}

const forgotPasswordAction = () => {
	router.push({ name: 'forgot_password' })
}

const redirectToSignIn = () => {
	setTimeout(() => {
		router.push({ name: 'signin' })
	}, 1000)
}

const resetPasswordAction = async () => {
	validateForm()

	if (!isErrorPassword.value) {
		try {
			const { isChanged } = await AuthService.resetPasswordByTokenAction(form)
			showSuccessAlert.value = isChanged
			redirectToSignIn()
		} catch (err) {
			const message: string = err.response.data?.message
			if (message.includes('invalid token')) errors.password = 'change-password.token_expired'
		}
	}
}

const submitButtonLabel = computed(() => {
	if (showSuccessAlert.value) {
		return t('change-password.redirecting_signin_page')
	} else if (isTokenValid.value) {
		return t('buttons.change-password')
	} else {
		return t('buttons.forgot-password')
	}
})
const submitButtonAction = () =>
	isTokenValid.value ? resetPasswordAction() : forgotPasswordAction()

return { __sfc: true,useRouter, t, router, props, token, form, errors, isErrorPassword, showSuccessAlert, showFailedAlert, isTokenValid, validateForm, setPassword, forgotPasswordAction, redirectToSignIn, resetPasswordAction, submitButtonLabel, submitButtonAction, TextField, PageTitle, AlertBanner, AlphaButtonAv }
}

})